import type { StructureModuleDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-collection-structure/output.dto'

export function computeInitialOpenSections(
  modules: StructureModuleDTO[],
  currentArticleSlug: string
): number[] {
  return modules
    .map((module, index) =>
      module.articles.some(article => article.slug === currentArticleSlug) ? index : null
    )
    .filter((index): index is number => index !== null)
}
